export default __webpack_public_path__ + "static/media/reddit-logo.0d20ab93.png";